export default "__VITE_PUBLIC_ASSET__44f302e4__"